import { Component, Renderer } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { VisitDetailPage } from '../visit-detail/visit-detail';
import { StaffDetailPage } from '../staff-detail/staff-detail';
import { VisitorProvider } from '../../providers/visitor/visitor';
import { ToastProvider } from '../../providers/toast/toast';
import { StaffProvider } from '../../providers/staff/staff';
import { Platform } from 'ionic-angular/platform/platform';
import { App } from 'ionic-angular/components/app/app';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-visitor-modal',
  templateUrl: 'visitor-modal.html',
})
export class VisitorModalPage {
  item = {};
  id: number;
  message = "";
  title = "";
  audio : any;
  itemImage : any;
  itemPurpose : any;
  itemName: any;
  itemMobile : any;
  isSoundActive :any;
  constructor(
    private app: App,
    public navParams: NavParams, 
    private viewCtrl: ViewController,
    private visitorProvider: VisitorProvider,
    private staffProvider: StaffProvider,
    private translate: TranslateService,
    private toast: ToastProvider,
    private platform: Platform,
    private renderer: Renderer,
    ) {
    this.audio = new Audio();
    this.audio.src='https://ismdoc.s3.amazonaws.com/public/asset/dec6.wav'
    // this.audio.src = 'https://ism-complaint-mirror.s3.amazonaws.com/public/NOTICE/21/611f79516b71f_qwBDegNAvBFNB7U4xOds2021082009_dec1.wav';
    console.log('UserId', navParams.get('id'), navParams.get('message'));
    this.id = navParams.get('id');
    this.message = navParams.get('message');
    this.title = navParams.get('title');
    if(this.title == "visit"){
      this.getNotificationStatus();   
      this.visitorProvider.getVisitById(this.id).then(val => {
        if(val.status == "success"){
          this.item = val.data;
          this.itemImage = this.item['image'];
          this.itemName = this.item['name'];
          this.itemPurpose = this.item['purpose'];
          this.itemMobile = this.item['mobile']
          console.log(this.item,"item")
        }
      });
    }else if(this.title == "staff"){
      this.staffProvider.getStaffById(this.id).then(val => {
        if(val.status == "success"){
          this.item = val.data;
        }
      });
    }
    var className =  this.title == "visit" ? 'popup-big-popup' : 'popup'
    this.renderer.setElementClass(viewCtrl.pageRef().nativeElement, className, true);
  }

  playRingtone () {
    console.log("play counter")
    this.audio.play();
    setTimeout(() => {
      this.audio.pause();
      console.log("pause called")
  }, 6000);
    // this.audio.loop = true;
    }
    
  stopRingtone () {
    // console.log("stop")
    this.audio.pause();
    }

  
  onGoto(){

    if(this.title == "visit"){
      this.visitorProvider.getVisitById(this.id).then(val => {
        if(val.status == "success"){
          this.app.getRootNav().push(VisitDetailPage, val.data);
          this.dismiss();
        }
      });
    }else if(this.title == "staff"){
      this.staffProvider.getStaffById(this.id).then(val => {
        if(val.status == "success"){
          this.app.getRootNav().push(StaffDetailPage, {
            data: val.data
          });
          this.dismiss();
        }
      });
    }
  }

  onAccept(){
    console.log("accept called");
    this.visitorProvider.allow({id: this.id}).then(val => {
      this.stopRingtone();
      if(val.status == "success"){
        this.toast.presentToast("Visit accepted");
        this.dismiss();
      }else{
        this.toast.presentToast(val.message);
      }
    });
  }

  onReject(){
    this.visitorProvider.deny({id: this.id}).then(val => {
      this.stopRingtone();
      if(val.status == "success"){
        this.toast.presentToast("Visit rejected");
        this.dismiss();
      }else{
        this.toast.presentToast(val.message);
      }
    });
  }

  getNotificationStatus(){
   this.visitorProvider.getNotificationStatus().then(val => {
   this.isSoundActive = val.data[0].switch !=0 ? true : false;
   if(this.isSoundActive){
    this.playRingtone();
   }
  })
  }

  

  exit(){
    if(this.navParams.get("exitApp")){
      this.platform.exitApp();
    }else{
      this.dismiss();
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VisitorModalPage');
  }

  dismiss() {
    this.stopRingtone();
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/visitor-modal/visitor-modal.ts